<div class="d-flex justify-content-between">
    <div
      class="font-5 w-100 d-flex align-items-center position-relative me-2 user-card fw-light primary-border p-2 rounded-3"
    >
      {{ name() }}
    </div>
  
    <div
      class="font-5 w-100 d-flex align-items-center position-relative me-2 user-card fw-light primary-border p-2 rounded-3"
    >
      {{ value() }}
    </div>
  </div>
  